/**
 * Marca de dispositivo del chat público (DD3): sin estado, firmada con su propio
 * secreto y prefijo de dominio (DD12, DD21), así que no vale como sesión ni al
 * revés. `d` es el día UTC en que el dispositivo abrió sesión.
 */
export interface DeviceMark {
  d: string
  sid: string
}

/**
 * Firma y lee la marca de dispositivo. `read` devuelve `null` para cualquier
 * valor que no sea una marca auténtica: forjada, de otro uso o ilegible.
 */
export interface IPublicChatDeviceMarkCodec {
  sign(mark: DeviceMark): string
  read(value: string): DeviceMark | null
}

/** Lo que el dispositivo trae al abrir: la cookie firmada y la fecha que guarda la isla (`deviceUsedOn`). */
export interface DeviceEvidence {
  mark: string | null
  usedOn: string | null
}

const UTC_DAY = /^\d{4}-\d{2}-\d{2}$/

/** El día UTC de `now` como `YYYY-MM-DD`. */
export function utcDayOf(now: Date): string {
  return now.toISOString().slice(0, 10)
}

export function readDeviceMarkPayload(value: unknown): DeviceMark | null {
  if (typeof value !== 'object' || value === null) return null
  const { d, sid } = value as Record<string, unknown>
  if (typeof d !== 'string' || !UTC_DAY.test(d) || typeof sid !== 'string') return null
  return { d, sid }
}
